import React from 'react';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import OutsourcedFeeService from '../../../Services/OutsourcedFeeService';
import ErrorMessage from '../../../Elements/ErrorMessage';

class CloseOutsourcedFeeWindowDescription extends React.Component {
  static titleForEdit = 'Close Outsourced Fee';

  static serviceFunction = (editedItem) => OutsourcedFeeService.Close(editedItem);

  static errorHandler = (error) => ErrorMessage.SetWarning(error);

  static pagesInGeneralEditWizzard = [
    {
      label: 'Close',
      fields: [
        {
          fieldName: 'EndDate',
          label: 'End Date',
          className: 'col-12',
          type: InputTypesEnum.Date,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
      ],
    },
  ];
}

export default CloseOutsourcedFeeWindowDescription;
